module.exports = `${require.publicPath}faq-bg.81e2b794.png`;